<template>
  <div class="flex">
    <ui-list-date-selector-tab-item
      v-for="(date, index) in hazards.dates"
      :key="date"
      v-model="selectedDateIndex"
      :label="date"
      :index="index"
      @update:model-value="hazards.setSelectedDateIndex($event)"
    />
  </div>
</template>

<script setup lang="ts">
import { useHazardsStore } from '@/features/hazards';
import { computed } from 'vue';

const hazards = useHazardsStore();

const selectedDateIndex = computed(() => hazards.selectedDateIndex);
</script>
